



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { collapseEvent, expandEvent, itemSelectedEvent } from './dropdown.const';
import Dropdown from './dropdown.vue';

@Component({
  components: {
    Dropdown
  },
  inheritAttrs: false
})
export default class SimpleDropdown<T> extends Vue {
  @Prop({ required: true })
  items: T[];

  expanded = false;
  selectedItemIndex = -1;

  events = {
    [collapseEvent]: this.collapse,
    [expandEvent]: this.expand,
    [itemSelectedEvent]: this.selected
  };

  expand() {
    this.expanded = true;
  }

  collapse() {
    this.expanded = false;
  }

  selected(selectedIndex: number) {
    this.selectedItemIndex = selectedIndex;
    this.$emit(itemSelectedEvent, this.items[selectedIndex] || null);
  }
}
